import { createFileRoute } from '@tanstack/react-router'
import { PartnerRouteGuard } from '../../components/PartnerRouteGuard'
import { PartnerDashboard } from '../../components/PartnerDashboard'

export const Route = createFileRoute('/partner/dashboard')({
  component: () => (
    <PartnerRouteGuard>
      <PartnerDashboard />
    </PartnerRouteGuard>
  ),
})
